/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Crumb_DeviceInputs */

const en_ui_onboarding_crumb_device = /** @type {(inputs: Ui_Onboarding_Crumb_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stays on this device`)
};

const de_ui_onboarding_crumb_device = /** @type {(inputs: Ui_Onboarding_Crumb_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleibt auf diesem Gerät`)
};

/**
* | output |
* | --- |
* | "Stays on this device" |
*
* @param {Ui_Onboarding_Crumb_DeviceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_crumb_device = /** @type {((inputs?: Ui_Onboarding_Crumb_DeviceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Crumb_DeviceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_crumb_device(inputs)
	return de_ui_onboarding_crumb_device(inputs)
});